import React, { Component } from 'react';
import { SearchIcon } from 'lucide-react';
interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}
/**
 * Standardized SearchInput Component
 * Guarantees no icon/text overlap with precise positioning
 */
export function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className = ''
}: SearchInputProps) {
  return <div className={`relative flex items-center ${className}`} data-id="element-371">
      {/* Icon: Fixed width container, absolutely positioned, non-interactive */}
      <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none z-10 w-5 h-5" data-id="element-372">
        <SearchIcon className="w-5 h-5 text-gray-400" strokeWidth={2} data-id="element-373" />
      </div>
      {/* Input: Force padding with inline style to override any conflicts */}
      <input type="text" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="w-full h-[42px] pr-4 py-2.5 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all text-sm leading-tight bg-white" style={{
      paddingLeft: '56px',
      minHeight: '42px'
    }} data-id="element-374" />
    </div>;
}